import { toast } from "sonner";
import { Link2, Instagram, Facebook } from "lucide-react";

const SITE = "https://centrodiparodontologia.com";

const WaIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor" aria-hidden="true"><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.5-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6l.4-.5c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.1 4.9 4.3 2.4.9 2.9.8 3.4.7.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.1-.3-.2-.6-.3zM12 21.8c-1.8 0-3.5-.5-5-1.4l-.4-.2-3.7 1 1-3.6-.2-.4A9.8 9.8 0 1 1 12 21.8zm0-21.6A11.8 11.8 0 0 0 1.9 17.9L.2 24l6.3-1.7A11.8 11.8 0 1 0 12 .2z" /></svg>
);

const wrap = (ctx, text, max) => text.split(" ").reduce((lines, w) => {
  const last = lines[lines.length - 1];
  if (last && ctx.measureText(`${last} ${w}`).width <= max) lines[lines.length - 1] = `${last} ${w}`;
  else lines.push(w);
  return lines;
}, []);

const loadImg = (src) => new Promise((res, rej) => { const i = new Image(); i.crossOrigin = "anonymous"; i.onload = () => res(i); i.onerror = rej; i.src = src; });

const makeStory = async (a, cover) => {
  const c = document.createElement("canvas");
  c.width = 1080; c.height = 1920;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#F4F3EC"; ctx.fillRect(0, 0, 1080, 1920);
  let y = 200;
  if (cover) {
    const img = await loadImg(cover).catch(() => null);
    if (img) {
      const w = 920, h = 690, s = Math.max(w / img.width, h / img.height);
      ctx.save(); ctx.beginPath(); ctx.roundRect(80, 160, w, h, [460, 460, 48, 48]); ctx.clip();
      ctx.drawImage(img, 80 + (w - img.width * s) / 2, 160 + (h - img.height * s) / 2, img.width * s, img.height * s);
      ctx.restore(); y = 960;
    }
  }
  ctx.fillStyle = "#3E6B48"; ctx.font = "500 30px 'JetBrains Mono', monospace";
  ctx.fillText(a.category.toUpperCase().split("").join(" "), 90, y);
  ctx.fillStyle = "#1B3B28"; ctx.font = "500 92px 'Cormorant Garamond', serif";
  wrap(ctx, a.title, 900).forEach((l, i) => ctx.fillText(l, 86, y + 120 + i * 96));
  ctx.fillStyle = "#1B3B28"; ctx.beginPath(); ctx.roundRect(90, 1700, 900, 120, 60); ctx.fill();
  ctx.fillStyle = "#FCFBF7"; ctx.font = "500 36px 'Plus Jakarta Sans', sans-serif"; ctx.textAlign = "center";
  ctx.fillText("Leggi su centrodiparodontologia.com", 540, 1772);
  return new Promise((res) => c.toBlob(res, "image/png"));
};

export const ShareBar = ({ a, cover, place = "top" }) => {
  const url = `${SITE}/blog/${a.slug}`;
  const text = `${a.title} — ${url}`;
  const copy = async () => { await navigator.clipboard?.writeText(url); toast.success("Link copiato"); };
  const story = async () => {
    const blob = await makeStory(a, cover);
    const file = new File([blob], `${a.slug}-storia.png`, { type: "image/png" });
    if (navigator.canShare?.({ files: [file] })) {
      await navigator.share({ files: [file], title: a.title }).catch(() => {});
      return;
    }
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob); link.download = file.name; link.click();
    await navigator.clipboard?.writeText(url);
    toast.success("Immagine per la storia scaricata e link copiato: caricala su Instagram e aggiungi lo sticker link.");
  };
  const btn = "inline-flex items-center gap-2 rounded-full border border-[#1B3B28]/15 px-4 py-2.5 text-sm text-[#1B3B28] hover:bg-[#E6ECE4] transition-colors";
  return (
    <div className="mt-8 flex flex-wrap items-center gap-2" data-testid={`share-bar-${place}`}>
      <span className="eyebrow text-[#526356] mr-2">Condividi</span>
      <a className={btn} href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noopener noreferrer" data-testid={`share-whatsapp-${place}`}><WaIcon /> WhatsApp</a>
      <a className={btn} href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer" data-testid={`share-facebook-${place}`}><Facebook size={16} /> Facebook</a>
      <button className={btn} onClick={story} data-testid={`share-instagram-story-${place}`}><Instagram size={16} /> Storia Instagram</button>
      <button className={btn} onClick={copy} data-testid={`share-copy-link-${place}`}><Link2 size={16} /> Copia link</button>
    </div>
  );
};
